/* eslint-disable import/prefer-default-export */

/* eslint-disable func-names */
import { callApiServiceCommon } from "../service-common";

const api = process.env.REACT_APP_API;

export function* getStoreInfomation() {
  const payload = {
    method: "GET",
    url: `${api}/v2/get-shop-settings`,
    params: {},
  };
  return yield callApiServiceCommon(payload);
}

export function* saveStoreInfomation(param, shop) {
  const payload = {
    method: "POST",
    url: `${api}/v2/save-shop-settings`,
    params: {
      shop_domain: shop,
      owner_first_name: param.owner_first_name,
      owner_last_name: param.owner_last_name,
      owner_title: param.owner_title,
      shop_name: param.shop_name,
      phone_number: param.phone_number,
      website: param.website,
      email: param.email,
      address: param.address,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getCurrentPackage() {
  const payload = {
    method: "GET",
    url: `${api}/v2/get-current-package-he-v2`,
    params: {},
  };
  return yield callApiServiceCommon(payload);
}

export function* changePlanPackage({
  price_name,
  year_charge,
  apply_sales_event,
}) {
  const payload = {
    method: "POST",
    url: `${api}/register-charge`,
    params: {
      price_name,
      year_charge,
      apply_sales_event,
    },
  };
  return yield callApiServiceCommon(payload);
}
export function* verifySenderEmail({ email }) {
  const payload = {
    method: "POST",
    url: `${api}/check-verify-sender-email`,
    params: {
      email,
    },
  };
  return yield callApiServiceCommon(payload);
}
export function* sendEmailverifySenderEmail(data) {
  const payload = {
    method: "POST",
    url: `${api}/send-verify`,
    params: {
      sender_email: data.payload,
    },
  };
  return yield callApiServiceCommon(payload);
}
